import React, { Component } from 'react';
import { Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import ApiService from '../../service/ApiService';
import { Link } from 'react-router-dom';

class StockUpgradeDowngradeFull extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: [],
            symbol: this.props.symbol,
            limit: this.props.limit
        };
    }

    componentDidMount() {
        ApiService.getUpgradeDowngrade(this.state.symbol, this.state.limit).then(result => {
            console.log('Upgrade Downgrade', result);
            let filteredData = [];
            let length = this.state.limit === undefined ? 200 : this.state.limit;
            if (result.length > 0) {
                length = result.length < length ? result.length : length;
                for (var i = 0; i < length; i++) {
                    filteredData.push(result[i]);
                }
            }
            this.setState({ list: filteredData });
        })
            .catch((error) => {
                console.log(error);
            });
    }

    renderRow(listValue) {
        if (listValue !== undefined && listValue.symbol !== undefined) {
            let url = '/chart/' + listValue.symbol;

            let resultColor = '';
            if (listValue.action.toLowerCase() == 'upgrade') {
                resultColor = 'green';
            } else if (listValue.action.toLowerCase() == 'downgrade') {
                resultColor = 'red';
            }
            return (
                <tr key={listValue.publishedDate + listValue.gradingCompany + Math.random()} style={{ color: resultColor }}>
                    <td><Link to={url}>{listValue.symbol}</Link></td>
                    <td style={{ color: resultColor, width: '12%' }}>{listValue.publishedDate.split('T')[0]}</td>
                    <td style={{ color: resultColor }}>{listValue.gradingCompany}</td>
                    <div><a href={listValue.newsURL} target="_blank" rel="noreferrer" style={{ color: resultColor }}>{listValue.newsTitle}</a></div>
                    <td style={{ color: resultColor }}>{listValue.priceWhenPosted.toFixed(0)}</td>
                    <td style={{ color: resultColor }}>{this.capitalizeFirstLetter(listValue.action)}</td>
                </tr>
            )
        }
    }

    capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    render() {
        let tableRow;
        if (this.state.list === undefined || this.state.list.length <= 0) {
            tableRow = <tr><td></td><td>No Data</td><td></td><td></td><td></td><td></td></tr>
        } else {
            tableRow = this.state.list.map(this.renderRow.bind(this));
        }

        let header = 'Upgrades or Downgrades';
        if (this.state.symbol !== undefined) {
            header = <><Link to={'/upgradeDowngrade/' + this.state.symbol}>{header}</Link></>
        } else {
            header = 'News';
        }

        return (
            <div>
                <Table striped bordered hover size="xs" style={{ fontSize: "10px" }}>
                    <thead>
                        <tr>
                            <th>Ticker</th>
                            <th>Date</th>
                            <th>Company</th>
                            <th>{header}</th>
                            <th>Price When Posted</th>
                            <th>Action&nbsp;&nbsp;
                                <OverlayTrigger
                                    placement="left"
                                    overlay={<Tooltip id="button-tooltip-2" style={{ wordBreak: 'break-all' }}>
                                        Hedge Funds/Big Investor sets upgrade or downgrade action periodically based on the Company performance<br />
                                    </Tooltip>}>
                                    <i style={{ color: '#8A2BE2', fontSize: '15px' }} className={"fa fa-question-circle"}></i>
                                </OverlayTrigger>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableRow}
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default StockUpgradeDowngradeFull;
